interface SSEEvent {
    id: string;
    event: string;
    data: string;
}

interface PartialSSEEvent {
    id?: string;
    event?: string;
    data?: string;
}

const isCompleteSSEEvent = (event: PartialSSEEvent): event is SSEEvent => {
    return event.id !== undefined && event.event !== undefined && event.data !== undefined;
};

export const parseSSEChunk = (chunk: string): SSEEvent[] => {
    const events: SSEEvent[] = [];
    const lines = chunk.split('\n');
    let currentEvent: PartialSSEEvent = {};

    for (const line of lines) {
        if (line.trim() === '') {
            // Empty line indicates end of event
            if (isCompleteSSEEvent(currentEvent)) {
                events.push(currentEvent);
            }
            currentEvent = {};
        } else if (line.startsWith('data:')) {
            currentEvent.data = line.substring(5).trim();
        } else if (line.startsWith('id:')) {
            currentEvent.id = line.substring(3).trim();
        } else if (line.startsWith('event:')) {
            currentEvent.event = line.substring(6).trim();
        }
    }

    // Handle case where chunk doesn't end with empty line
    if (isCompleteSSEEvent(currentEvent)) {
        events.push(currentEvent);
    }

    return events;
};
